// extracted by mini-css-extract-plugin
export var active = "CityesList-module--active--77ceb";
export var address = "CityesList-module--address--078c6";
export var city = "CityesList-module--city--23c66";
export var fadeInAnimation = "CityesList-module--fadeInAnimation--9fd4d";
export var item = "CityesList-module--item--35ad6";
export var items = "CityesList-module--items--41484";
export var list = "CityesList-module--list--dd680";
export var phone = "CityesList-module--phone--b19e7";
export var smallScreenItem = "CityesList-module--smallScreenItem--f93c9";